import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=70c4af52"
import script from "../../controllers/item/item-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/item/item-list.js?vue&type=script&lang=js&external"
import style0 from "./ItemList.vue?vue&type=style&index=0&id=70c4af52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports